import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { stateEnum, apiRoute } from "../constants/enum.js"
import customAPI from "../api/customAPI.js"
import { toast } from "react-toastify"

const { grayStock } = stateEnum

const initialState = {

  currentGrayStock: {
    item_code: "",
  },
  filter: {
    todate: "",
    fromdate: "",
    itemCode: "",
    mitemCode: "",
    itemName: "",
    mitemName: "",
    unitId: "",
    isAging: false
  },
}

export const setStockEntryDetail = createAsyncThunk(
  "graystock/fetchChallanDetail",
  async ({ token, comp_code, transaction_id, db_user, bill_type }) => {
    try {
      const { data } = await customAPI.post(
        apiRoute.transaction.graySaleChallanEntry.fetchEntryDetail,
        {
          compcode: comp_code,
          transactionid: transaction_id,
          billtype: bill_type,
          db_user: db_user
        },
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      )
      return data.data
    } catch (error) {
      toast.error("Data not found", {
        position: "top-center"
      })
      console.log(error)
    }
  }
)

// export const setBillDetail = createAsyncThunk(
//   "Stock/fetchBillDetail",
//   async ({ token, comp_code, acid, billno, billtype, db_user }) => {

//     try {
//       const { data } = await customAPI.post(
//         apiRoute.report.invoice.fetchInvoiceDetail,
//         {
//           compcode: comp_code,
//           ac_id: acid,
//           bill_no: billno,
//           bill_type: billtype,
//           db_user: db_user
//         },
//         {
//           headers: {
//             Authorization: "Bearer " + token,
//           },
//         }
//       )

//       return data.data
//     } catch (error) {
//       console.log(error)
//     }
//   }
// )

const grayStockSlice = createSlice({
  name: grayStock,
  initialState,
  reducers: {
    setCurrentGrayStock: (state, action) => {
      state.currentGrayStock = {
        item_code: action.payload.item_code
      }
    },
    resetCurrentGrayStock: (state, action) => {
      state.account = {
        item_code: ""
      }
    },
    setFilter: (state, action) => {
      console.log(action.payload, "pay")
      state.filter = {
        itemCode: action.payload.itemCode,
        mitemCode: action.payload.mitemCode,
        itemName: action.payload.itemName,
        mitemName: action.payload.mitemName,
        todate: action.payload.todate,
        fromdate: action.payload.fromdate,
        unitId: action.payload.unitId,
        isAging: action.payload?.isAging
      }
    },
    resetGrayFilter: (state) => {
      state.filter = {
        itemCode: "",
        mitemCode: "",
        itemName: "",
        mitemName: "",
        todate: null,
        fromdate: null,
        unitId: "",
        isAging: false
      }
    },

  },
  // extraReducers: (builder) => {
  //   builder
  //     .addCase(setStockEntryDetail.fulfilled, (state, action) => {
  //       state.detail = action.payload;
  //     })
  //     .addCase(setStockEntryDetail.rejected, (state, action) => [
  //       state.detail = []
  //     ])
  // }
})

export const { setCurrentGrayStock, resetCurrentGrayStock, setFilter, resetGrayFilter, } = grayStockSlice.actions
export default grayStockSlice.reducer
